"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ColorBox_1 = __importDefault(require("./ColorBox"));
var styles_1 = require("./styles");
var constants_1 = require("./constants");
var InformationColorsComponent = function () { return (react_1.default.createElement(styles_1.RootBox, null,
    react_1.default.createElement(styles_1.TitleTypography, { variant: "h3" }, "Information Colors"),
    react_1.default.createElement(styles_1.GridBox, null,
        constants_1.INFORMATION_COLORS_GRID.map(function (_a) {
            var color = _a.color, label = _a.label;
            return (react_1.default.createElement(ColorBox_1.default, { key: color, color: color, label: label, isSemantic: label.includes('Semantic') }));
        }),
        constants_1.BACKGROUND_COLORS.map(function (_a) {
            var color = _a.color, label = _a.label;
            return (react_1.default.createElement(ColorBox_1.default, { key: color, color: color, label: label, isSemantic: label.includes('Semantic'), bold: true }));
        })))); };
exports.default = InformationColorsComponent;
//# sourceMappingURL=InformationColorsComponent.js.map